/**
 * El orden por gravedad, en el cliente.  (FR-007, SC-002)
 *
 * El servidor ya ordena así en `/conversations`. Pero el flujo en vivo EMPUJA
 * filas sueltas (`setQueryData`), y al mezclarlas hay que RE-ORDENAR en el
 * cliente — si no, una conversación recién escalada aparecería al final en vez
 * de arriba, que es justo lo contrario de lo que SC-002 exige.
 *
 * Es una RÉPLICA del `PESO` del servidor (`conversations.list.routes.ts`). Si
 * uno cambia, cambian los dos: el desenlace manda, y "los problemas primero" es
 * la promesa central de la herramienta.
 */

/** Menor peso = más arriba. Los problemas (handover, abandono) primero. */
export const PESO: Record<string, number> = {
    handover: 0,
    abandoned: 1,
    in_progress: 2,
    expired: 3,
    booked: 4,
    modified: 4,
    cancelled: 4,
    informed: 4,
    waiting: 4,
    unmatched: 4,
}

export interface Ordenable {
    outcome: string
    lastObservedAt: string // ISO-8601
}

/**
 * Ordena por gravedad y, a igualdad, por lo más reciente. No muta la entrada.
 */
export function ordenarPorGravedad<T extends Ordenable>(items: T[]): T[] {
    return [...items].sort(
        (a, b) => (PESO[a.outcome] ?? 9) - (PESO[b.outcome] ?? 9) || b.lastObservedAt.localeCompare(a.lastObservedAt),
    )
}
